// third-party
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

// project import
import { portalAPI, rtkQueryErrorHandler } from './api/portalAPI';
import { apiStatusMiddleware } from './middleware/apiStatusMiddleware';
import { timecardPersistenceMiddleware } from './middleware/timecardPersistence';
import reducers from './reducers';
// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat([portalAPI.middleware, rtkQueryErrorHandler, timecardPersistenceMiddleware, apiStatusMiddleware]),
});

// Without it no query hears the window regain focus or the browser come back online.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { dispatch, persister, store, useDispatch, useSelector };
